import React, { Component } from 'react';
import axios from 'axios';
import {loginUser} from './HelperFunctions';
import {Globals} from './constants';
const queryString = require('query-string');

class AuthenticationForZain extends Component {
	constructor(props) {
        super(props);
        this.state = {
        };

        this.apiPath = Globals.NodeApi+"api/";
        
    };

    async componentDidMount() {
        let cgObject = JSON.parse(localStorage.getItem('cgObject')), 
                       redirectTo = '/login',
                       logRequest = {cgObject: cgObject, params: this.props.location.search};

        let params = queryString.parse(this.props.location.search);

        setTimeout( async () => {
            if (cgObject) {

                if (params.status === "success") {
                    let url = "https://me.cricwick.net/userapi/create_subscription_by_token_sla?web_user=1&service_id=1&telco=zain_kw&token=" + params.token;
        
                    let serverResponse = await axios.get(url, {});
                    serverResponse = serverResponse.data;
        
                    if (serverResponse.subscribed_status) {
                        let userObject = {
                            call_type: "SLA_ZAIN",
                            subscribed: 1,
                            phone: serverResponse.msisdn,
                            telco: 'zain_kw'
                        }

                        localStorage.setItem('user_logged_in', true);
                        localStorage.setItem('user', JSON.stringify(userObject));
                        loginUser(userObject);
                    } else {
                        localStorage.removeItem('cgObject');
                        window.location.href=redirectTo;
                    }
        
                } else {
                    localStorage.removeItem('cgObject');
                    window.location.href=redirectTo;
                }
            }
            
            localStorage.removeItem('cgObject');
            window.location.href=redirectTo;
        }, 5000)
        
    }

    render() {
        return(
          <section id="main-section" className="px-lg-0 jc-inner-page align-self-start">
            <div className="main-loader card min-height-80vh">
                <img width="64" height="64" src="/images/loader_v2.gif" alt="" />
            </div>
          </section>
        )
      }

}

export default AuthenticationForZain;